// src/components/guide/QuickComposer.jsx
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { useGuide } from '../../contexts/GuideContext';
import { services } from '../../services/productBrain';

export const firstSentence = text => (String(text).trim().split(/(?<=[.!?])\s|\n/)[0] || '').replace(/[.!?]+$/, '').slice(0, 90);
const TYPES = [['interview', 'Customer quote'], ['support_ticket', 'Support ticket'], ['analytics', 'Data point']];

export default function QuickComposer() {
  const { composer, closeComposer } = useGuide();
  const [text, setText] = useState(composer.text);
  const [title, setTitle] = useState(firstSentence(composer.text));
  const [edited, setEdited] = useState(false);
  const [type, setType] = useState('interview');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const save = async e => {
    e.preventDefault(); setBusy(true); setError('');
    try {
      if (!text.trim() || !title.trim()) throw new Error('Paste what the customer said first.');
      const problem = await services.problems.create({ title: title.trim(), description: text.trim(), status: 'discovered', severity: 'medium' });
      await services.evidence.create({ problem_card_id: problem.id, type, title: text.trim().slice(0, 160), description: text.trim(), observed_at: new Date().toISOString(), strength: 3 });
      closeComposer();
    } catch (err) { setError(err.message || 'Could not save. Try again.'); } finally { setBusy(false); }
  };
  return <Dialog open onOpenChange={open => !open && !busy && closeComposer()}><DialogContent aria-label="Capture a customer problem" className="v2-dialog guide-composer">
    <DialogHeader><DialogTitle>Capture a customer problem</DialogTitle></DialogHeader>
    <form onSubmit={save} className="v2-form-grid">
      <label className="v2-field wide"><span>What did the customer say?</span><textarea rows={4} autoFocus value={text} placeholder="Paste a quote, complaint or note…" onChange={e => { setText(e.target.value); if (!edited) setTitle(firstSentence(e.target.value)); }}/></label>
      <label className="v2-field wide"><span>Problem title</span><input value={title} onChange={e => { setTitle(e.target.value); setEdited(true); }}/></label>
      <label className="v2-field"><span>Kind of evidence</span><select value={type} onChange={e => setType(e.target.value)}>{TYPES.map(([value, label]) => <option key={value} value={value}>{label}</option>)}</select></label>
      {error && <p className="v2-error wide" role="alert">{error}</p>}
      <div className="v2-actions wide"><button type="submit" className="v2-button" disabled={busy}>{busy ? 'Saving…' : 'Save problem and evidence'}</button><button type="button" className="v2-button secondary" disabled={busy} onClick={closeComposer}>Cancel</button></div>
    </form>
  </DialogContent></Dialog>;
}
